import SignUp from '@/modules/auth/sign-up/sign-up';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/sign-up/')({
  component: RouteComponent
});

function RouteComponent() {
  return <SignUp />;
}
